'use strict';
namespace TR {
    class SelectedAttractionCtrl {
        private attractionsBasket: any;
        private totalPrice: number = 0;
        private totalCurrency: string = 'GBP';
        public showAttractionsInfo: boolean = true;

        constructor(private basketStore:any,
                    private attractionService:any) {
        }

        getCount() : Number {
            return this.attractionsBasket.length;
        }

        toggleInfo() : void {
            this.showAttractionsInfo = !this.showAttractionsInfo;
        }

        getItems() : any {
            return this.attractionsBasket;
        }

        getTotalPrice() : number {
            return this.totalPrice;
        }

        getTotalCurrency() : string {
            return this.totalCurrency;
        }
    }

    angular
        .module('TR')
        .controller('SelectedAttraction', SelectedAttractionCtrl);
}
